import API from '../../../../api/EtelAPI';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import EditSectionCheckBox from '../../../../presentation/EditSectionCheckBox';
import Overlay from '../../../../presentation/Overlay';
import PageAuthorize from '../../../../security/PageAuthorize';
import React from 'react';
import Alerts from '../../../../prototypes/Alerts';
import Creatable from 'react-select';
import 'react-select/dist/react-select.css';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import clone from 'clone';
import EtelAPI from '../../../../api/EtelAPI';
import ReactTooltip from 'react-tooltip';
import KeyMapper from '../../../../prototypes/KeyMapper';
import RouteTitle from '../../../../presentation/RouteTitle';
import WaveModule from 'wavesurfer';
import DialerDetectionExamplesDialog from './DialerDetectionExamplesDialog.js';
import DialerDetectionUserQueueDialog from './DialerDetectionUserQueueDialog.js';

class DialerDetection extends React.Component {
  constructor( props ) {
    super( props );
    this.state = {
      keyMapper: new KeyMapper(),
      autocomplete: [],
      autoplay: true,
      currentRecordingURL: '',
      currentUUID: '',
      dialerNotes: {'label':'not a dialer','value':'not a dialer'},
      dialerValidated: 1,
      isDialerOptionSelected: false,
      dialerNoteOptions: [],
      recordingDirectory: '/vfiles/',
      recordingUUIDs: [],
      wave: null,
      shownewdialernoteinput: false,
      newdialernote: '',
      submitting: false,
      saveAsExample: false,
      waveConfiguration: {
        backend: 'MediaElement',
        barHeight: 1,
        container: '#WaveContainer',
        cursorColor: 'palevioletred',
        hideScrollbar: true,
        mediaControls: true,
        progressColor: 'fuchsia',
        waveColor: 'rebeccapurple',
        skipLength: 1,
      },
      showExamplesDialog: false,
      showUserQueue: false
    };

    // Component Events
    this.radioDialer = this.radioDialer.bind( this );
    this.setAutoplay = this.setAutoplay.bind( this );
    this.setDialerNotes = this.setDialerNotes.bind( this );
    this.shortcutKeys = this.shortcutKeys.bind( this );
    this.onInputKeyDown = this.onInputKeyDown.bind( this );
    this.submit = this.submit.bind( this );
    this.onHandleAddNewDialerNote = this.onHandleAddNewDialerNote.bind( this );
    this.onHandleNewDialerNoteChange = this.onHandleNewDialerNoteChange.bind( this );
    this.isDuplicateDialerNote = this.isDuplicateDialerNote.bind( this );
    this.addNewDialerNote = this.addNewDialerNote.bind( this );
    this.onValidate = this.onValidate.bind( this );
    this.onRenderDialerNoteOptions = this.onRenderDialerNoteOptions.bind( this );
    this.onRenderButtons = this.onRenderButtons.bind( this );
    this.setSaveAsExample = this.setSaveAsExample.bind( this );
    this.onCloseExamplesDialog = this.onCloseExamplesDialog.bind( this );
    this.onOpenExamplesDialog = this.onOpenExamplesDialog.bind( this );
    this.onManageQueue = this.onManageQueue.bind( this );
    this.onCloseUserQueue = this.onCloseUserQueue.bind( this );
    this.onFocus = this.onFocus.bind( this );

    // Key Map Events
    this.onPressedEnter = this.onPressedEnter.bind( this );
    this.onPressedTab = this.onPressedTab.bind( this );
    this.onPressedEscape = this.onPressedEscape.bind( this );
    this.onPressedPlayPause = this.onPressedPlayPause.bind( this );
    this.onPressedDialerOption = this.onPressedDialerOption.bind( this );
    this.onPressedNotADialerOption = this.onPressedNotADialerOption.bind( this );
    this.onPressedOption = this.onPressedOption.bind( this );
    this.onPressedSubmit = this.onPressedSubmit.bind( this );
    this.loadKeyMaps = this.loadKeyMaps.bind( this );
    this.getRecordings = this.getRecordings.bind( this );
    this.getPredictiveFill = this.getPredictiveFill.bind( this );
    this.getTopDialerNotes = this.getTopDialerNotes.bind( this );
    this.loadNextTrack = this.loadNextTrack.bind( this );
    this.onHandleGetFiles = this.onHandleGetFiles.bind( this );
    this.onPressedArrowKey = this.onPressedArrowKey.bind( this );

    // THIS IS FOR TESTING PURPOSES TO LOAD A TEST .WAV FILE
    this.onLoadWavFile = this.onLoadWavFile.bind( this );

    // Error Handling
    this.doLogOff = this.doLogOff.bind( this );
    this.onHandleException = this.onHandleException.bind( this );
  }

  componentDidMount() { // Initialize module after window is defined

    window.addEventListener( 'keydown', this.shortcutKeys );

    this.WaveModule = WaveModule;

    this.loadKeyMaps();
   
    this.getTopDialerNotes();

    this.getPredictiveFill();
  }

  //This is here because I am rushing and can't devote more time to lifecycle renderings and DOM js manipulation
  componentWillReceiveProps( nextProps ) {
    if ( this.state.wave === {} ) {
      this.setState( {
        wave: this.WaveModule.create( this.state.waveConfiguration )
      } );
    }
  }

  componentWillUnmount() {
    window.removeEventListener( 'keydown', this.shortcutKeys );
  }

  loadKeyMaps() {

    let keyMapper = this.state.keyMapper;

    // Keys added to the events triggered on press
    keyMapper.addKeyMap( 'Enter', this.onPressedEnter );
    keyMapper.addKeyMap( 'Tab', this.onPressedTab );
    keyMapper.addKeyMap( 'Esc', this.onPressedEscape );
    keyMapper.addKeyMap( ' ', this.onPressedPlayPause );
    keyMapper.addKeyMap( 'd', this.onPressedDialerOption );
    keyMapper.addKeyMap( 'D', this.onPressedDialerOption );
    keyMapper.addKeyMap( 'n', this.onPressedNotADialerOption );
    keyMapper.addKeyMap( 'N', this.onPressedNotADialerOption );
    keyMapper.addKeyMap( 's', this.onPressedSubmit, false, true, false );
    keyMapper.addKeyMap( 'S', this.onPressedSubmit, false, true, false );
    keyMapper.addKeyMap( '0', this.onPressedOption );
    keyMapper.addKeyMap( '1', this.onPressedOption );
    keyMapper.addKeyMap( '2', this.onPressedOption );
    keyMapper.addKeyMap( '3', this.onPressedOption );
    keyMapper.addKeyMap( '4', this.onPressedOption );
    keyMapper.addKeyMap( '5', this.onPressedOption );
    keyMapper.addKeyMap( '6', this.onPressedOption );
    keyMapper.addKeyMap( '7', this.onPressedOption );
    keyMapper.addKeyMap( '8', this.onPressedOption );
    keyMapper.addKeyMap( '9', this.onPressedOption );
    keyMapper.addKeyMap( 'ArrowLeft', this.onPressedArrowKey );
    keyMapper.addKeyMap( 'ArrowRight', this.onPressedArrowKey );

    // THIS IS FOR TESTING PURPOSES TO LOAD A TEST .WAV FILE
    keyMapper.addKeyMap( '`', this.onLoadWavFile );

    this.setState( {
      keyMapper: keyMapper
    } );
  }

  // THIS IS FOR TESTING PURPOSES TO LOAD A TEST .WAV FILE
  // 'https://dev.etelcommunications.com/vfiles/test.wav'
  // Uncomment the function, the binding, and the keymap
  onLoadWavFile( event ) {
    let myWM = this.WaveModule.create( this.state.waveConfiguration );

    this.setState( {
      wave: myWM
    }, () => {
      this.state.wave.load( '/vfiles/test.wav' );
    } );
  }

  onPressedArrowKey( event ) {
    if ( event.key === 'ArrowLeft' ) {
      this.state.wave.skipBackward();
    } else if ( event.key === 'ArrowRight' ) {
      this.state.wave.skipForward();
    }
  }

  // Event map for when user pressed Enter
  onPressedEnter( event ) {
    if ( event.target.tagName !== 'BUTTON' ) {
      this.submit();
    }
  }

  // Event map for when user pressed Tab
  onPressedTab( event ) {
    this.dialerNotesInput.focusStartOption();
  }

  onPressedEscape( event ) {
    this.dialerNotesInput.blur();
  }

  // Event map for when user pressed Space Bar
  onPressedPlayPause( event ) {
    let { bugsnag, dispatch } = this.props;
    let alerts = new Alerts( bugsnag, dispatch );
    const wave = this.state.wave;
    if( wave !== undefined && wave !== null ) {
      wave.playPause();
    } else {
      alerts.WARNING( 'Dialer Detection', 'Could not load audio component.',2500 );
    } 
  }

  // Event Map for when user pressed d or D
  onPressedDialerOption( event ) {

    let newoptions = clone( this.state.dialerNoteOptions );

    newoptions.map( ( option, index ) => {
      if( option.DefaultNote === 0 ) {
        option.checked = false;  
      }
      return option;
    } );

    this.setState( {
      isDialerOptionSelected: true,
      dialerValidated: 0,
      dialerNoteOptions: newoptions,
      dialerNotes: { 'label':'','value':'' }
    } );    
    
  }

  // Event for dialer notes being focused (clicked). Set the radio button to be a dialer.
  onFocus ( event ) {
    this.setState( {
      isDialerOptionSelected: true,
      dialerNotes: { 'label': '', 'value': ''}
    } );
  }

  // Event for when user pressed n or N
  onPressedNotADialerOption( event ) {

    let newoptions = clone( this.state.dialerNoteOptions );

    newoptions.map( ( option, index ) => {
      if( option.DefaultNote === 0 ) {
        option.checked = false;  
      }
      return option;
    } );

    this.setState( {
      isDialerOptionSelected: false,
      dialerValidated: 1,
      dialerNoteOptions: newoptions,
      dialerNotes: { 'label':'not a dialer','value':'not a dialer' }
    } );

    return;

  }

  // Event Map for when user pressed 0 through 9
  onPressedOption( event ) {
    const dialerValidated = this.state.isDialerOptionSelected === true ? 0 : 1;
    const options = clone( this.state.dialerNoteOptions );
    let dialerNotes = clone( this.state.dialerNotes );
    let oldoption = undefined;
    let newoption = undefined;

    // Get the old option selected, and new option selected
    let newoptions = options.map( ( option ) => {
      if( ( option.DialerValidated === dialerValidated ) && 
          ( parseInt( option.OrdinalPosition - 1, 10 ) === parseInt( event.key, 10 ) ) ) {
        newoption = option;
      } else {
        if( option.checked === true ) {
          oldoption = option;
        }
      }
      return option;
    } );

    // Verify the new option was found and if so then go ahead and selected it and set the new dialer note
    if( newoption !== undefined ) {
      newoption.checked = true;
      dialerNotes = { 'label': newoption.DialerNotes, 'value': newoption.DialerNotes };
      if( oldoption !== undefined ) {
        oldoption.checked = false;
      }
    }
    
    this.setState( {
      dialerNoteOptions: newoptions,
      dialerNotes: dialerNotes
    } );
  }

  // Event Map for when user pressed 'Alt + s or Alt + S'
  onPressedSubmit( event ) {
    this.submit( );
  }

  doLogOff() {
    const { dispatch } = this.props;
    const auth = this.props.auth;
    const history = this.props.history;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  onHandleException( e ) {
    const title = 'Dialer Detection';
    const bugsnag = this.props.bugsnag;
    const { dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const status = e.status === undefined ? 0 : e.status;
    if ( status === 401 ) {
      alerts.INFO( title, 'Your session has expired.', 5000 );
      this.doLogOff();
    } else if ( status === 500 ) {
      alerts.INFO( title, e.statusText, 5000 );
      this.doLogOff();
    } else {
      e.statusText = e.toString();
      alerts.CRITICAL( title, e );
    }
  }
  
  getRecordings() { // Only get more recordings when the client has zero
    const { dispatch } = this.props;
    const Bugsnag = this.props.bugsnag;
    const alerts = new Alerts( Bugsnag, dispatch );
    if ( this.state.recordingUUIDs.length === 0 ) {
      const api = new API( 'dialerdetection' );
      api.get().then( ( result ) => {
        if ( result.length > 0 ) {
          this.setState( {
            recordingUUIDs: result.map( ( e ) => {
              return e.M_UUID;
            } ).filter( ( k ) => {
              return k;
            } ),
          }, () => {
            this.loadNextTrack();
          } );
        } else {
          alerts.INFO( 'Dialer Detection', 'Good Job, You listened to all of the files', 5000 );
        }
      } ).catch( ( error ) => {
        this.onHandleException( error );
      } );
    }
  }

  getPredictiveFill( ) {
    const api = new API( 'dialerdetection/predict' );
    return api.get().then( ( result ) => {
      let hadError = '';
      let myWM = {};
      try {
        myWM = this.WaveModule.create( this.state.waveConfiguration );
      } catch ( error ) {
        hadError = true;
      }
      this.setState( {
        autocomplete: result.map( ( e ) => {
          return { label: e.DialerNotes, value: e.DialerNotes };
        }, [] ),
        wave: myWM,
        hadError: hadError
      }, () => {
        if ( this.state.hadError !== true ) {
          this.getRecordings();
        }
      } );
    }, ( ) => {
      this.getTopDialerNotes( );
    } ).catch( ( error ) => {
      this.onHandleException( error );
    } );
  }

  getTopDialerNotes( ) {
    const api = new EtelAPI( 'dialerdetection/topdialernotes' );
    return api.get().then( ( results ) => {
      let options = results.map( ( item ) => {
        item.checked = false;
        return item;
      } );
      this.setState( {
        dialerNoteOptions: options
      } );
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );
  }

  loadNextTrack() {
    if ( this.state.recordingUUIDs.length ) {
      // Get next UUID and create recording URL from it
      const currentUUID = this.state.recordingUUIDs.pop();
      // USE THIS FOR TESTING: 'https://dev.etelcommunications.com/vfiles/test.wav'
      // USE THIS FOR PROD: this.state.recordingDirectory + currentUUID + '.mp3',
      this.setState( {
        currentUUID: currentUUID,
        currentRecordingURL: this.state.recordingDirectory + currentUUID + '.mp3', 
      }, () => {
        // Load track, creating wave form
        if ( this.state.wave.load === undefined ) {
          let hadError = '';
          let myWM = {};
          try {
            myWM = this.WaveModule.create( this.state.waveConfiguration );
          } catch ( error ) {
            hadError = true;
          }

          this.setState( {
            wave: myWM
            , hadError: hadError
          }, () => {
            this.state.wave.load( this.state.currentRecordingURL );
            if ( this.state.autoplay === true ) {
              this.state.wave.playPause();
            }
          } );
        } else {
          this.state.wave.load( this.state.currentRecordingURL );
          if ( this.state.autoplay === true ) {
            this.state.wave.playPause();
          }
        }
      } );
    } else {
      this.getRecordings();
    }
  }

  onHandleGetFiles() {
    this.getRecordings();
  }

  radioDialer( e ) {
    let dialerValidated = this.state.dialerValidated;
    let newoptions = clone( this.state.dialerNoteOptions );
    let dialerNotes = this.state.dialerNotes;
    const selectedoptioninfo = e.target.id.replace( 'dialer-notes-input-','' ).split( '-' );
    const selectedoptioncategory = parseInt( selectedoptioninfo[0], 10 );
    const selectedoptionindex = parseInt( selectedoptioninfo[1], 10 );
    let oldoption = undefined;
    let selectedoption = undefined;    

    // Uncheck all child options
    newoptions.map( ( option ) => {
      if( option.DialerValidated === selectedoptioncategory && option.OrdinalPosition === selectedoptionindex ) {
        selectedoption = option;
      } else {
        if( option.checked === true ) {
          oldoption = option;
        }
      }
      return option;
    } );

    if( selectedoption !== undefined ) {
      selectedoption.checked = true;
      if( oldoption !== undefined ) {
        oldoption.checked = false;
      }
    }

    if( selectedoption.DialerNotes === 'Dialer' ) {
      this.setState( {
        isDialerOptionSelected: true,
        dialerValidated: 0,
        dialerNoteOptions: newoptions,
        dialerNotes: {'label':'','value':''}
      } );
    } else if( selectedoption.DialerNotes === 'Not a Dialer' ) {

      this.setState( {
        isDialerOptionSelected: false,
        dialerValidated: 1,
        dialerNoteOptions: newoptions,
        dialerNotes: {'label':'not a dialer','value':'not a dialer'}
      } );

    } else {

      // Check and set all values from selected option
      dialerValidated = selectedoption.DialerValidated;
      dialerNotes = { 'label': selectedoption.DialerNotes, 'value': selectedoption.DialerNotes };

      this.setState( {
        isDialerOptionSelected: dialerValidated === 0 ? true : false,
        dialerNotes: dialerNotes,
        dialerValidated: dialerValidated,
        dialerNoteOptions: newoptions
      } );
  
    }
  }

  setSaveAsExample( e ) {
    this.setState( { saveAsExample: e.target.checked } );
  }

  setAutoplay( e ) {
    this.setState( { autoplay: e.target.checked } );
  }

  setDialerNotes( dialerNotes ) {
    this.setState( { dialerNotes: dialerNotes } );
  }

  shortcutKeys( e ) {

    // Prevent shortcuts when typing and to prevent double entry
    if ( e.target && ( e.target.tagName === 'INPUT' || e.target.tagName === 'AUDIO' ) ) {
      return;
    }
    
    const keyMapper = this.state.keyMapper;
    
    keyMapper.testKeyMap( e );

  }

  isDuplicateDialerNote( dialerNote ) {
    const options = this.state.autocomplete;
    for ( var index = 0; index < options.length; index++ ) {
      const option = options[index];
      if ( option.value.toString() === dialerNote.toString() ) {
        return true;
      }
    }
    return false;
  }

  addNewDialerNote( dialerNote ) {
    let options = clone( this.state.autocomplete );
    const newDialerNote = { label: dialerNote, value: dialerNote };
    options.push( newDialerNote );
    this.setState( {
      dialerNotes: newDialerNote,
      autocomplete: options
    } );
  }

  onInputKeyDown( e ) {

    if( this.state.submitting === true ) {
      e.preventDefault();
      return;
    }

    if ( e.key === 'Enter' ) {
      if ( this.isDuplicateDialerNote( e.target.value ) === false ) {
        this.addNewDialerNote( e.target.value );
        this.submitButton.focus( );
      } else {
        const newDialerNote = { label: e.target.value, value: e.target.value };
        this.setState( {
          dialerNotes: newDialerNote
        }, () => {
          this.submitButton.focus( );
        } );
      }
    }
  }

  onValidate() {
    const { dispatch } = this.props;
    const Bugsnag = this.props.bugsnag;
    const alerts = new Alerts( Bugsnag, dispatch );
    if ( !this.state.dialerNotes.value ) {
      alerts.INFO( 'Dialer Detection', 'You must supply a valid entry in the dialer notes text field.', 5000 );
      return false;
    } else if ( this.state.dialerValidated === null || this.state.dialerValidated === -2 ) {
      alerts.INFO( 'Dialer Detection', 'You must check one of the buttons indicating whether or not this is a dialer.', 5000 );
      return false;
    } else if ( !this.state.currentUUID ) {
      alerts.INFO( 'Dialer Detection', 'You listened to all of the recordings!', 5000 );
      return false;
    }
    return true;
  }

  onManageQueue( e ) {
    this.setState( {
      showUserQueue: true
    } );
  }

  onCloseUserQueue( e ) {
    this.setState( {
      showUserQueue: false
    } );
  }

  submit() {
    const { dispatch } = this.props;
    const Bugsnag = this.props.bugsnag;
    const alerts = new Alerts( Bugsnag, dispatch );
    
    this.setState( {
      submitting: true
    }, () => {
        
      if ( this.onValidate() === true ) {
        const message = {
          DialerNotes: this.state.dialerNotes.value.toLowerCase(),
          DialerValidated: this.state.dialerValidated,
          M_UUID: this.state.currentUUID,
          SaveAsExample: this.state.saveAsExample ? 1 : 0
        };
        const api = new API( 'dialerdetection' );
        api.update( message ).then( ( result ) => {
          if ( this.state.dialerValidated === '1' ) {
            this.setState( { dialerValidated: '0' } );
          }
          alerts.SUCCESS( 'Dialer Detection', 'Success', 2000 );
          this.setState( {
            submitting: false,
            saveAsExample: false
          }, () => {
            this.submitButton.blur( );
            this.getTopDialerNotes( );
            this.loadNextTrack();
          } );
        } ).catch( ( error ) => {
          let exception = { statusText: 'Failed To Submit Record.' };
          this.onHandleException( exception );
          this.setState( {
            submitting: false
          } );
        } );
      } else {
        this.setState( {
          submitting: false
        } );
      }

    } );

  }

  onHandleAddNewDialerNote( ) {
    const shownewdialernoteinput = this.state.shownewdialernoteinput;
    if( shownewdialernoteinput === false ){
      this.setState( {
        shownewdialernoteinput: true,
        newdialernote: ''
      } );
    } else {
      const { bugsnag, dispatch } = this.props;
      const alerts = new Alerts( bugsnag, dispatch );
      const newdialernote = this.state.newdialernote;
      if( newdialernote.trim().length > 0 ){
        const isDuplicate = this.isDuplicateDialerNote( newdialernote );
        if( isDuplicate === false ) {
          let autocomplete = this.state.autocomplete;
          const newdialernoteoption = { 'label': newdialernote, 'value': newdialernote };
          autocomplete.push( newdialernoteoption );
          this.setState( {
            autocomplete: autocomplete,
            shownewdialernoteinput: false
          } );
          alerts.SUCCESS( 'Dialer Detection', 'Successfully added new dialer note.', 2500 );
        } else {
          alerts.WARNING( 'Dialer Detection', {'statusText':'This dialer note already exists.'} , 2500 );
          this.setState( {
            newdialernote: '',
            shownewdialernoteinput: false
          } );
        }
      } else {
        this.setState( {
          newdialernote: '',
          shownewdialernoteinput: false
        } );
      }
    }
  }

  onHandleNewDialerNoteChange( e ) {
    this.setState( {
      newdialernote: e.target.value
    } );
  }

  onRenderDialerNoteOptions( dialerValidated ) {
    let dialerNoteOptions = [];
    const options = this.state.dialerNoteOptions;
    const group = dialerValidated === 0 ? 'dialergroup' : 'notadialergroup';
    let position = 0;
    for( var index = 0; index < options.length; index++ ) {
      const option = options[ index ];
      if( option !== undefined ) {
        if( option.DialerValidated === dialerValidated ) {
          const ordinal = parseInt( option.OrdinalPosition, 10 );
          const optionKey = 'dialer-notes-option-' + dialerValidated.toString() + '-' + ordinal.toString();
          const inputid = 'dialer-notes-input-' + dialerValidated.toString() + '-' + ordinal.toString();
          const tooltipid = 'dialer-notes-tooltip-' + dialerValidated.toString() + '-' + ordinal.toString();
          let keyMapDescription = 'Press ' + ( position ).toString();

          if( option.DefaultNote === 1 && option.DialerNotes === 'Dialer' ) {
            keyMapDescription = 'Press D';
            dialerNoteOptions.push( 
              <label key={optionKey} style={{'display':'flex','alignItems':'center','justifyContent':'center','height':'20px','width':'100%'}} >
                <span className='radio-group-desc'><strong>({keyMapDescription})</strong></span>
                <input id={inputid} type='radio' name={'dialer-default'} onChange={this.radioDialer} value={ordinal} checked={this.state.isDialerOptionSelected} style={{'marginLeft':'5px'}} tabIndex="0" />
                <span className='radio-group-header' style={{'marginLeft':'5px'}} >{option.DialerNotes}</span>
              </label>
            );
            dialerNoteOptions.push( <br key={'break-dialer'} /> );
          } else if( option.DefaultNote === 1 && option.DialerNotes === 'Not a Dialer' ) {
            keyMapDescription = 'Press N';
            dialerNoteOptions.push( 
              <label id={optionKey} key={optionKey} style={{'display':'flex','alignItems':'center','justifyContent':'center','height':'20px','width':'100%'}} >
                <span className='radio-group-desc'><strong>({keyMapDescription})</strong></span>
                <input id={inputid} type='radio' name={'dialer-default'} onChange={this.radioDialer} value={ordinal} checked={!this.state.isDialerOptionSelected} style={{'marginLeft':'5px'}} tabIndex="0" />
                <span className='radio-group-header' style={{'marginLeft':'5px'}}>{option.DialerNotes}</span>
              </label>
            );
            dialerNoteOptions.push( <br key={'break-not-a-dialer'} /> );
          } else {
            dialerNoteOptions.push( 
              <label key={optionKey} style={{'display':'flex','alignItems':'center','justifyContent':'center','height':'20px','width':'100%'}}>
                <span className='radio-group-desc'><strong>({keyMapDescription})</strong></span>
                <input id={inputid} type='radio' name={group} onChange={this.radioDialer} value={ordinal} checked={option.checked} style={{'marginLeft':'10px'}} tabIndex="-1" />
                <span className='radio-group-item-label' data-tip={tooltipid} data-for={tooltipid} style={{'marginLeft':'10px'}}>{option.DialerNotes}</span>
                <ReactTooltip id={tooltipid}>{option.DialerNotes}</ReactTooltip>
              </label>
            );
            position += 1;
          }
        }
      }
    }
    return ( dialerNoteOptions );
  }

  /**
   * Handles the opening of the Examples Dialog.
   * 
   * @param {event} e 
   */
  onOpenExamplesDialog( e ) {
    this.setState( {
      showExamplesDialog: true
    } );
  }

  /**
   * Handles the closing of the Examples dialog.
   * 
   * @param {event} e 
   */
  onCloseExamplesDialog( e ) {
    this.setState( {
      showExamplesDialog: false
    } );
  }

  onRenderButtons( ) {
    if( this.state.submitting === false ) {
      if( this.hadError === true ) {
        return (
          <button className='submit-button' onClick={this.onHandleGetFiles.bind( this )} tabIndex='1'> Get Voicefiles </button>
        );
      } else {
        return (
          <button ref={ ( button ) => this.submitButton = button } className='submit-button' tabIndex='1' onClick={this.submit}>Submit (Alt+S)</button>
        );
      }
    } else {
      return (
        <button className='submit-button' tabIndex='2' >Please wait...</button>
      );
    }
  }

  

  render() {
    const shownewdialernoteinput = this.state.shownewdialernoteinput;
    const dialernoteinputclass = shownewdialernoteinput === true ? 'dialer-notes-input-shrink' : 'dialer-notes-input';
    let newdialernoteinput = ( <input className='dialer-notes-new-input-hidden' type='text' value='' /> );
    if( shownewdialernoteinput === true ) {
      newdialernoteinput = (
        <input className='dialer-notes-new-input' type='text' value={this.state.newdialernote} placeholder='Enter new dialer note here' onChange={this.onHandleNewDialerNoteChange} />
      );
    }

    const showOverlay = this.state.showExamplesDialog ? true : false || this.state.showUserQueue === true ? true: false;

    return (
      <PageAuthorize groups={['Administrators', 'Operations', 'Management', 'Interns']}>
        <RouteTitle title={'Dialer Detection'} />
        <div className='view-examples-section-test'>
          <button className="view-examples-button" onClick={this.onOpenExamplesDialog}>View Examples</button>
        </div>
        <div className='dialer-detection'>
          <div className='dialer-detection-section first-section'>
            <div className='radio-group first-group'>
              {this.onRenderDialerNoteOptions( 0 )}
            </div>
            <div className='radio-group second-group'>
              {this.onRenderDialerNoteOptions( 1 )}
            </div>
            <div className='dialer-notes-group'>
              <label className="dialer-notes-group-header"><strong>Dialer Notes</strong></label><br />
              <span className="dialer-notes-section">
                <Creatable id="dialerNotesInput" ref={ ( input ) => this.dialerNotesInput = input } className={dialernoteinputclass} disabled={!this.state.autocomplete} onChange={this.setDialerNotes} onFocus={this.onFocus} onInputKeyDown={this.onInputKeyDown} options={this.state.autocomplete} placeholder={'Dialer Notes'} value={this.state.dialerNotes} tabIndex="1" />
                {newdialernoteinput}
                <i className="dialer-notes-add-note-icon icon-fontello-doc-new" onClick={this.onHandleAddNewDialerNote} />
              </span>
              <span className="button-group">
                <span className="button-group-col-1">
                  <EditSectionCheckBox key='SaveAsExample' 
                    onChanged={this.setSaveAsExample} 
                    label='Save Example' 
                    checked={this.state.saveAsExample} 
                    labelFontSize="12pt" 
                    labelFontBold={true} 
                    data-for='SaveAsExampleTooltip' 
                    data-tip='SaveAsExampleTooltip' />  
                  <ReactTooltip id='SaveAsExampleTooltip'>
                    Checking copy this audio to the examples page.
                  </ReactTooltip>
                </span>
                <span className="button-group-col-2">
                  { this.onRenderButtons( ) }
                </span>
              </span>
            </div>
          </div>
          <div className="dialer-detection-buttons">
            <button className="dialer-detection-manage-queue-button" onClick={this.onManageQueue}>Manage User Queue</button>
          </div>
          <div className='dialer-detection-section'>
            <div className="voice-file-group">
              <label className="voice-file-group-header">
                <span>{'Voice File Panel - '}</span>
                <span style={{'color':'#273339','marginLeft':'5px'}}>{' (Press Spacebar to Pause/Play audio)'}</span>
                <EditSectionCheckBox key='Autoplay' onChanged={this.setAutoplay} label='Auto Play Voice File' checked={this.state.autoplay} />
              </label>
              <div id='WaveContainer' className="voice-file-wave-container" tabIndex="2" />
            </div>
          </div>
        </div>
        <Overlay show={showOverlay} />
        <DialerDetectionExamplesDialog show={this.state.showExamplesDialog} onClose={this.onCloseExamplesDialog} />
        <DialerDetectionUserQueueDialog show={this.state.showUserQueue} onClose={this.onCloseUserQueue} />
      </PageAuthorize>
    );
  }
}

export default withRouter(
  connect(
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( DialerDetection ) );


// WEBPACK FOOTER //
// ./src/content/enterprise/dialerdetection/components/DialerDetection.js